import jquery from 'jquery';
import { get } from 'lodash';

interface JQRails extends JQueryStatic {
  rails: {
    ajax: typeof jquery.ajax;
  };
}

const jQuery = ($ as JQRails);

export const ajax = jQuery.ajax;

export const extractAPIError = (err: JQuery.jqXHR) => {
  try {
    return get(JSON.parse(err.responseText), 'error', 'Unknown error has occured');
  } catch (e) {
    return 'Unknown error has occured';
  }
};

export default jQuery;
